var gql = require("@apollo/client").gql;

const BEAUTIFUL_PHONES_QUERY = gql`
	query BeautifulPhones(
		$filter: String
		$providerId: Int
		$regionId: Int
		$limit: Int
		$offset: Int
		$providerJoin: Boolean
	) {
		beautifulPhones(
			filter: $filter
			providerId: $providerId
			regionId: $regionId
			limit: $limit
			offset: $offset
			providerJoin: $providerJoin
		) {
			data {
				phone
				price
				tags {
					type
					name
					description
					translit
				}
				provider {
					id
					name
					url_name
					vip_provider
					mobile_operator
					logo
					logo_2
					logo_preview
					region {
						id
						name
						url
					}
					contacts {
						card
						phones
					}
					global {
						id
						name
					}
					operator_settings {
						numbers {
							value
							url
						}
					}
				}
			}
			pagination {
				items_count
				items_total
				per_page
				page_current
				page_total
			}
		}
	}
`;

export default BEAUTIFUL_PHONES_QUERY;
